import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles<ITheme>(theme => ({
  topWrapper: {
    textAlign: 'center',
    maxWidth: 568,
    width: '100%',
  },
  imgWrapper: {
    position: 'relative',
    paddingTop: '44.37%',
  },
  img: {
    position: 'absolute',
    top: theme.spacings.s0,
    left: theme.spacings.s0,
    width: '100%',
  },
  closeIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 24,
    height: 24,
    padding: theme.spacings.s2,
    borderRadius: theme.radiuses.circle,
    cursor: 'pointer',
    backgroundColor: '#0000004d',
    '& path': {
      fill: '#ffffff',
    },
  },
  textWrapper: {
    padding: `${theme.spacings.s40} ${theme.spacings.s24} 50px`,
  },
  title: {
    marginBottom: 12,
    fontSize: 16,
    fontWeight: 700,
    color: '#282b36',
    lineHeight: 1.4,
  },
  text: {
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 500,
    color: '#545869',
    lineHeight: 1.4,
  },
  indicatorsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  indicatorButton: {
    width: 8,
    height: 8,
    borderRadius: theme.radiuses.circle,
    '& + &': {
      marginInlineStart: 4,
    },
    color: '#bcc0d1',
    cursor: 'pointer',
  },
  activeIndicatorButton: {
    backgroundColor: '#7b8196',
    color: '#282b36',
  },
  infoButton: {
    borderRadius: theme.variables.mainBorderRadius,
    padding: `6px ${theme.spacings.s16}`,
    marginBottom: 20,
    backgroundColor: '#c209c1',
    fontSize: 12,
    fontWeight: 600,
    color: '#ffffff',
    lineHeight: 1.6,
    cursor: 'pointer',
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: '#ac00a6',
      },
    },
  },
}));

export default useStyles;
